import { cubingApi } from "./cubing";

export const {
  useLazySuggestBinConfigurationQuery,
  useSuggestBinConfigurationQuery,
  useGetSuggestedCompartmentsAndMaxFillCountsQuery,
  useSelectBinCompartmentMutation
} = cubingApi;
